// extracted by mini-css-extract-plugin
export default {"input":"QtyInput_input__fCRpc"};